import React from "react";
import { Header } from "./Header";
import { Footer } from "./Footer";
import { OrbitalGridBackground } from "./OrbitalGridBackground";
import { ENV } from "@/config/constants";

interface LayoutProps {
  children: React.ReactNode;
  showHeader?: boolean;
}

export function Layout({ children, showHeader = true }: LayoutProps) {
  return (
    <div
      className="relative isolate min-h-screen flex flex-col"
      style={{
        background: "var(--layout-background)",
      }}
    >
      <OrbitalGridBackground />
      {ENV !== "mainnet" && (
        <div className="relative z-10 w-full bg-foreground text-background text-center text-sm py-1 font-medium">
          {ENV === "private-mainnet" ? "Private Mainnet" : "Testnet"} — For testing purposes only
        </div>
      )}
      {showHeader && <Header />}
      <main
        className={`relative z-10 flex flex-col justify-start items-center flex-1 w-full pb-6 ${
          showHeader ? "pt-16" : "pt-6"
        }`}
      >
        {children}
      </main>
      <div className="relative z-10">
        <Footer />
      </div>
    </div>
  );
}
